import { type PlatformDataResponse, type Release } from "api/dashboardBackend";
import styles from "components/dashboard/release-card/ReleaseCardTitle.module.scss";
import { PlatformId } from "util/platform";

interface Props {
  release: Release;
  platformData: PlatformDataResponse;
}

const isNullish = (value: unknown) => value === null || value === undefined;

// Hiding build number from these platforms because it overflows UI and isn't needed to view at top level
const hideBuildNumber = (platformData: PlatformDataResponse) =>
  platformData.platform.id.toLowerCase() === PlatformId.China ||
  platformData.platform.id.toLowerCase() === PlatformId.Android;

// Map of version overrides: sometimes the appstore version metadata is different from the plist version
export const VERSION_OVERRIDES: Record<
  string,
  { majorMinor: string; patch: number }
> = {
  "7.71.0": { majorMinor: "7.70", patch: 1 },
};

// Function to modify the version number as needed
export const getDisplayVersion = (majorMinor: string, patch: number) => {
  const versionKey = `${majorMinor}.${patch}`;
  if (VERSION_OVERRIDES[versionKey]) {
    return VERSION_OVERRIDES[versionKey];
  }

  return { majorMinor, patch };
};

export const ReleaseCardTitle = ({ release, platformData }: Props) => {
  const displayVersion = getDisplayVersion(release.majorMinor, release.patch);

  return (
    <>
      <span className={styles.majorMinor}>{displayVersion.majorMinor}</span>
      <span className={styles.patch}>
        .{displayVersion.patch}
        {isNullish(release.build) || hideBuildNumber(platformData)
          ? ""
          : `.${release.build}`}
      </span>
    </>
  );
};

export default ReleaseCardTitle;
